import React from 'react';
import Body from './components/Body';
import Footer from './components/Footer';

import './style.scss';

interface ModalProps {
  show: boolean;
  title: string;
  children?: React.ReactNode[] | React.ReactNode;
}

const Modal = ({ show, title, children }: ModalProps) => {
  return (
    <div className={`modal fade${show ? ' show' : ''}`}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content bd-0 tx-14">
          <div className="modal-header pd-y-20 pd-x-25">
            <h6 className="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{title}</h6>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;
